import React from 'react';
import { Banknote } from 'lucide-react';

const LABELS = {
  cash: 'Cash',
  revolut: 'Revolut',
  bank_transfer: 'Bank Transfer',
  zippay: 'ZipPay',
  other: 'Other',
};

/**
 * Badges showing which DIRECT payment methods a driver accepts
 * (Pay Driver Directly model — no Stripe payout badge anymore).
 */
export function PaymentMethodBadges({ methods, size = 'sm', dataTestId }) {
  const list = (methods || []).filter((m) => LABELS[m]);
  const shown = list.length ? list : ['cash'];

  const sizeClasses = size === 'md' ? 'text-xs px-2 py-1 gap-1.5' : 'text-[10px] px-1.5 py-0.5 gap-1';
  const iconClasses = size === 'md' ? 'w-3.5 h-3.5' : 'w-3 h-3';

  return (
    <div className="inline-flex items-center gap-1.5 flex-wrap" data-testid={dataTestId}>
      {shown.map((m) => (
        <span
          key={m}
          className={`inline-flex items-center ${sizeClasses} bg-amber-100 text-amber-800 font-medium rounded whitespace-nowrap`}
          title={`Accepts ${LABELS[m]} paid directly to the driver`}
          data-testid={dataTestId ? `${dataTestId}-${m}` : undefined}
        >
          <Banknote className={iconClasses} strokeWidth={2} />
          {LABELS[m]}
        </span>
      ))}
    </div>
  );
}

export const DIRECT_METHOD_LABELS = LABELS;
export default PaymentMethodBadges;
